import React, { useState } from 'react'
import { DialogContent } from '@mui/material'
import PropTypes from 'prop-types'
import ModalContainer from '../Modals/ModalContainer'
import DataTable from '../@Common/DataTable'
import StyledLink from '../StyledLink'

function PartnerListingsModal({ listings, onClickClose }) {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })

  const columns = [
    {
      field: 'name',
      headerName: 'Listing Name',
      flex: 1,
      renderCell: ({ row }) => <StyledLink newWindow to={`partners/listings/${row.listingId}/offers/offers`} onClick={() => onClickClose()} contents={row.name} />,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 100,
    },
    {
      field: 'updatedOnUtc',
      type: 'date',
      headerName: 'Created On Date',
      width: 135,
      valueGetter: (params) => (params.row.updatedOnUtc ? new Date(params.row.updatedOnUtc) : null),
    },
  ]

  return (
    <ModalContainer
      title="Partner Listings"
      maxWidth="sm"
      actions={{
        secondaryAction: { label: 'Close', onClick: onClickClose },
      }}
    >
      <DialogContent sx={{ paddingLeft: '0px', paddingRight: '0px', paddingTop: '0px' }}>
        <div style={{ height: 400, width: '100%' }}>
          <DataTable
            getRowId={(row) => row.listingId}
            hideFooter={listings?.length <= 10}
            hideToolbar
            pagination={listings?.length > 10}
            paginationModel={paginationModel}
            onPaginationModelChange={(model) => setPaginationModel(model)}
            hideFooterRowCount
            disableColumnFilter
            rows={listings || []}
            columns={columns}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </div>
      </DialogContent>
    </ModalContainer>
  )
}

PartnerListingsModal.propTypes = {
  listings: PropTypes.arrayOf(
    PropTypes.shape({
      createdOnUtc: PropTypes.string,
      eligibleForGXMarketplace: PropTypes.bool,
      listingId: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
      updatedOnUtc: PropTypes.string,
    }),
  ).isRequired,
  onClickClose: PropTypes.func.isRequired,
}

export default PartnerListingsModal
